<template>
  <div>
    <el-table
        class="history-table"
        v-if="loyaltyHistory"
        :data="loyaltyHistory"
        v-loading="loading"
        style="width: 100%">
      <el-table-column label="Тип услуги"
      >
        <template slot-scope="scope">
          <div class="procedure-title">{{ scope.row.procedure.title }}</div>
        </template>

      </el-table-column>
      <el-table-column label="Дата"
      >
        <template slot-scope="scope">
          <div class="date">
            <div class="date__title">{{ $root.dateDefault(scope.row.start) }}</div>
            <div class="date__title">{{ $root.timeIso(scope.row.start) }}</div>
          </div>

        </template>
      </el-table-column>

      <el-table-column label="Тип посещения">
        <template slot-scope="scope">
          <p v-if="scope.row.need_validation">Абонемент</p>
          <p v-else>Единоразовое</p>
        </template>
      </el-table-column>
      <el-table-column label="Место">
        <template slot-scope="scope">
          <div class="info-department" v-if="scope.row.department">
            <icon-department size="18" class="department-icon"></icon-department>
            {{ scope.row.department.title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Валидация">
        <template slot-scope="scope">
          <div v-if="scope && scope.row.can_validated" class="history-table__radio-validation">
            <template>
              <el-radio @change="changeValidated(scope.row, true)" v-model="scope.row.validated" :label="true">да
              </el-radio>
              <el-radio @change="changeValidated(scope.row, false)" v-model="scope.row.validated" :label="false">
                нет
              </el-radio>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        v-if="showPagination"
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="pagination.per_page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        @current-change="loadLogic"
    />

    <router-link :to="{ name: 'cpanel.schedule' } ">
      <el-button type="primary" class="book-btn">Записать</el-button>
    </router-link>

    <appointment-modal
        :procedureData="{}"
        :visible="visibleModalAppointment"
        @close="closeAppointmentModal"
    />

  </div>
</template>
<script>
import IconDepartment from "@/components/icons/department.vue"
import AppointmentModal from "@/components/ganttCalendar/modal/Appointment.vue"

import {mapActions, mapGetters} from "vuex"

export default {
  name: "Reservation",
  data() {
    return {
      pagination: {},
      loyaltyHistory: [],
      loading: false,
    }
  },
  components: {IconDepartment, AppointmentModal},
  props: {
    user: {
      required: true
    }
  },
  watch: {
    user() {
      this.loadLogic()
    }
  },
  mounted() {
    this.loadLogic()
  },
  computed: {
    ...mapGetters("appointment", {
      visibleModalAppointment: "visibleModalAppointment",
    }),
    sign() {
      return this.typeItem === 'decrease' ? '-' : '+'
    },
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false;
    },
  },
  methods: {
    ...mapActions({
      setCurrentUser: "appointment/SET_CURRENT_USER",
      openModalAppointment: "appointment/OPEN_MODAL_APPOINTMENT",
      getAppointment: "appointment/GET_APPOINTMENT",
      setDepartment: "appointment/SET_CURRENT_DEPARTMENT",
    }),
    bookUser() {
      // todo нужно продумать логику выбора департамента

    },
    closeAppointmentModal() {
      this.dataAppointmentModal = {}
    },
    changeValidated(data, value) {
      this.loading = true
      this.$api.appointments.validate(data.department.id, data.id, {
        validate: value
      }).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((res) => {
        this.$notify.error({
          title: "Упс..",
          message: res.response.data.message,
        })
      }).finally(() => {
        this.loading = false

        this.$emit('reloadDataUser')
      })

    },
    loadLogic(page = 1) {
      this.loading = true

      let data = {
        params: {
          search: this.typeItem === "history" ? "" : this.typeItem,
          page,
          limit: 10
        }
      }

      this.$api.user.appointment(this.user.id, data)
          .then((response) => {
            this.loyaltyHistory = response.data.data
            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    goAppointment(el) {
      this.$router.push({name: "cpanel.schedule", params: {date: el.start}});
    }

  }
}
</script>
<style lang="scss" scoped>
.history-table {
  margin-top: 0;

  /deep/ tr .cell {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 13px;

    color: #8E8E93;
  }

  /deep/ tr:nth-child(odd) {
    background-color: #EFEFF4;
  }

  /deep/ .el-table__row {
    td {
      cursor: pointer;
      padding: 9px 0 !important;
      border-bottom: 0 !important;
    }

    td:last-child {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }

    td:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
  }

  &__radio-validation {
    white-space: nowrap;
  }

}


.procedure-title {
  width: max-content;

  text-align: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  color: #111111;
}

.date {


  &__title {
    font-size: 13px;

    color: #111111;
  }
}


.time {
  font-size: 13px;
  line-height: 1;

  display: flex;
  align-items: center;

  &__badge {
    background: #b7bac0;
    border-radius: 2px;
    padding: 2px;
    margin: 0 4px;

    color: #fff;
    font-size: 11px;
  }
}


.info-department {
  display: flex;
  align-items: center;

  text-overflow: ellipsis;

  color: #111;

  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  .department-icon {
    width: 18px;
  }
}


.pagination {
  padding: 0;
  margin: 10px 0 0 -5px;
}

/deep/ .el-radio {
  margin-right: 16px !important;
}

.book-btn {
  margin-top: 10px;
}
</style>
